export default __webpack_public_path__ + "static/media/bars.a2e35dd5.svg";